export type CheckInVisitorStatus = "active" | "expired" | "revoked";

/** Someone who scanned a check-in's QR code, i.e. the temporary project grant that scan created. */
export class CheckInVisitor {
  constructor(
    public readonly userUuid: string,
    /** The last scan: scanning again renews the grant. */
    public readonly checkedInAt: Date,
    public readonly expiresAt: Date | null,
    /** When someone took the visitor's access away; null if that did not happen. */
    public readonly revokedAt: Date | null,
  ) {}

  /** The access was taken away on purpose, whatever the expiry says. */
  get isRevoked(): boolean {
    return this.revokedAt !== null;
  }

  /** The grant has ended: the visitor no longer has access to the project. */
  get isExpired(): boolean {
    return this.expiresAt !== null && this.expiresAt.getTime() <= Date.now();
  }

  /** `revoked` wins over `expired`: a revoked visitor stays revoked once the grant would have run out. */
  get status(): CheckInVisitorStatus {
    if (this.isRevoked) {
      return "revoked";
    }
    return this.isExpired ? "expired" : "active";
  }

  static fromJson(json: any): CheckInVisitor {
    return new CheckInVisitor(
      json["user_uuid"],
      new Date(json["checked_in_at"]),
      json["expires_at"] ? new Date(json["expires_at"]) : null,
      json["revoked_at"] ? new Date(json["revoked_at"]) : null,
    );
  }
}
